var e = /* @__PURE__ */ ((l) => (l.selectAll = "selectAll", l.noResultText = "noResultText", l.searchPlaceholder = "searchPlaceholder", l.iconAriaLabel = "iconAriaLabel", l.listboxAriaLabel = "listboxAriaLabel", l))(e || {});
const o = {
  [e.selectAll]: "Vybrat vše",
  [e.noResultText]: "Nebyly nalezeny žádné výsledky",
  [e.searchPlaceholder]: "Hledat...",
  [e.iconAriaLabel]: "Rozbalovací nabídka",
  [e.listboxAriaLabel]: "neuspořádaný seznam"
}, n = {
  [e.selectAll]: "Vælg alle",
  [e.noResultText]: "Ingen resultater fundet",
  [e.searchPlaceholder]: "Søg...",
  [e.iconAriaLabel]: "Dropdown-menu",
  [e.listboxAriaLabel]: "uordnet liste"
}, a = {
  [e.selectAll]: "Alle auswählen",
  [e.noResultText]: "Keine Ergebnisse gefunden",
  [e.searchPlaceholder]: "Suchen...",
  [e.iconAriaLabel]: "Dropdown-Menü",
  [e.listboxAriaLabel]: "ungeordnete Liste"
}, s = {
  [e.selectAll]: "Alle auswählen",
  [e.noResultText]: "Keine Ergebnisse gefunden",
  [e.searchPlaceholder]: "Suchen...",
  [e.iconAriaLabel]: "Dropdown-Menü",
  [e.listboxAriaLabel]: "ungeordnete Liste"
}, t = {
  [e.selectAll]: "Επιλογή όλων",
  [e.noResultText]: "Δεν βρέθηκαν αποτελέσματα",
  [e.searchPlaceholder]: "Αναζήτηση...",
  [e.iconAriaLabel]: "Μενού αναπτυσσόμενης λίστας",
  [e.listboxAriaLabel]: "μη ταξινομημένη λίστα"
}, r = {
  [e.selectAll]: "Select All",
  [e.noResultText]: "No results found",
  [e.searchPlaceholder]: "Search...",
  [e.iconAriaLabel]: "Dropdown menu",
  [e.listboxAriaLabel]: "unordered list"
}, c = {
  [e.selectAll]: "Select All",
  [e.noResultText]: "No results found",
  [e.searchPlaceholder]: "Search...",
  [e.iconAriaLabel]: "Dropdown menu",
  [e.listboxAriaLabel]: "unordered list"
}, i = {
  [e.selectAll]: "Select All",
  [e.noResultText]: "No results found",
  [e.searchPlaceholder]: "Search...",
  [e.iconAriaLabel]: "Dropdown menu",
  [e.listboxAriaLabel]: "unordered list"
}, u = {
  [e.selectAll]: "Select All",
  [e.noResultText]: "No results found",
  [e.searchPlaceholder]: "Search...",
  [e.iconAriaLabel]: "Dropdown menu",
  [e.listboxAriaLabel]: "unordered list"
}, d = {
  [e.selectAll]: "Seleccionar todo",
  [e.noResultText]: "No se encontraron resultados",
  [e.searchPlaceholder]: "Buscar...",
  [e.iconAriaLabel]: "Menú desplegable",
  [e.listboxAriaLabel]: "lista desordenada"
}, A = {
  [e.selectAll]: "Seleccionar todo",
  [e.noResultText]: "No se encontraron resultados",
  [e.searchPlaceholder]: "Buscar...",
  [e.iconAriaLabel]: "Menú desplegable",
  [e.listboxAriaLabel]: "lista desordenada"
}, b = {
  [e.selectAll]: "Valitse kaikki",
  [e.noResultText]: "Ei tuloksia",
  [e.searchPlaceholder]: "Hae...",
  [e.iconAriaLabel]: "Pudotusvalikko",
  [e.listboxAriaLabel]: "järjestämätön lista"
}, h = {
  [e.selectAll]: "Tout sélectionner",
  [e.noResultText]: "Aucun résultat trouvé",
  [e.searchPlaceholder]: "Rechercher...",
  [e.iconAriaLabel]: "Menu déroulant",
  [e.listboxAriaLabel]: "liste non ordonnée"
}, L = {
  [e.selectAll]: "Tout sélectionner",
  [e.noResultText]: "Aucun résultat trouvé",
  [e.searchPlaceholder]: "Rechercher...",
  [e.iconAriaLabel]: "Menu déroulant",
  [e.listboxAriaLabel]: "liste non ordonnée"
}, x = {
  [e.selectAll]: "Tout sélectionner",
  [e.noResultText]: "Aucun résultat trouvé",
  [e.searchPlaceholder]: "Rechercher...",
  [e.iconAriaLabel]: "Menu déroulant",
  [e.listboxAriaLabel]: "liste non ordonnée"
}, R = {
  [e.selectAll]: "Tout sélectionner",
  [e.noResultText]: "Aucun résultat trouvé",
  [e.searchPlaceholder]: "Rechercher...",
  [e.iconAriaLabel]: "Menu déroulant",
  [e.listboxAriaLabel]: "liste non ordonnée"
}, p = {
  [e.selectAll]: "Összes kiválasztása",
  [e.noResultText]: "Nincs találat",
  [e.searchPlaceholder]: "Keresés...",
  [e.iconAriaLabel]: "Legördülő menü",
  [e.listboxAriaLabel]: "rendezetlen lista"
}, w = {
  [e.selectAll]: "Seleziona tutto",
  [e.noResultText]: "Nessun risultato trovato",
  [e.searchPlaceholder]: "Cerca...",
  [e.iconAriaLabel]: "Menu a discesa",
  [e.listboxAriaLabel]: "elenco non ordinato"
}, M = {
  [e.selectAll]: "Alles selecteren",
  [e.noResultText]: "Geen resultaten gevonden",
  [e.searchPlaceholder]: "Zoeken...",
  [e.iconAriaLabel]: "Keuzemenu",
  [e.listboxAriaLabel]: "onordende lijst"
}, D = {
  [e.selectAll]: "Velg alle",
  [e.noResultText]: "Ingen resultater funnet",
  [e.searchPlaceholder]: "Søk...",
  [e.iconAriaLabel]: "Rullegardinmeny",
  [e.listboxAriaLabel]: "uordnet liste"
}, T = {
  [e.selectAll]: "Zaznacz wszystko",
  [e.noResultText]: "Nie znaleziono wyników",
  [e.searchPlaceholder]: "Szukaj...",
  [e.iconAriaLabel]: "Menu rozwijane",
  [e.listboxAriaLabel]: "nieuporządkowana lista"
}, P = {
  [e.selectAll]: "Selecionar tudo",
  [e.noResultText]: "Nenhum resultado encontrado",
  [e.searchPlaceholder]: "Pesquisar...",
  [e.iconAriaLabel]: "Menu suspenso",
  [e.listboxAriaLabel]: "lista não ordenada"
}, B = {
  [e.selectAll]: "Selectează tot",
  [e.noResultText]: "Nu au fost găsite rezultate",
  [e.searchPlaceholder]: "Căutare...",
  [e.iconAriaLabel]: "Meniu derulant",
  [e.listboxAriaLabel]: "listă neordonată"
}, S = {
  [e.selectAll]: "Välj alla",
  [e.noResultText]: "Inga resultat funna",
  [e.searchPlaceholder]: "Sök...",
  [e.iconAriaLabel]: "Rullgardinsmeny",
  [e.listboxAriaLabel]: "oordnad lista"
}, g = {
  [e.selectAll]: "Hepsini seç",
  [e.noResultText]: "Sonuç bulunamadı",
  [e.searchPlaceholder]: "Ara...",
  [e.iconAriaLabel]: "Açılır menü",
  [e.listboxAriaLabel]: "sırasız liste"
};
export {
  o as DropdownMenuBaseCS,
  n as DropdownMenuBaseDA,
  a as DropdownMenuBaseDE,
  s as DropdownMenuBaseDEAT,
  t as DropdownMenuBaseEL,
  r as DropdownMenuBaseEN,
  c as DropdownMenuBaseENCA,
  i as DropdownMenuBaseENGB,
  u as DropdownMenuBaseENUS,
  d as DropdownMenuBaseES,
  A as DropdownMenuBaseESMX,
  b as DropdownMenuBaseFI,
  h as DropdownMenuBaseFR,
  L as DropdownMenuBaseFRBE,
  x as DropdownMenuBaseFRCA,
  R as DropdownMenuBaseFRCH,
  p as DropdownMenuBaseHU,
  w as DropdownMenuBaseIT,
  M as DropdownMenuBaseNL,
  D as DropdownMenuBaseNO,
  T as DropdownMenuBasePL,
  P as DropdownMenuBasePT,
  B as DropdownMenuBaseRO,
  S as DropdownMenuBaseSV,
  g as DropdownMenuBaseTR
};
